import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_multi-bank-checkout/artifacts/1jn1i2fd_image.png";

export default function Logo({ to = "/", className = "", showTagline = false, size = "md" }) {
  // Enlarged presets — the brand mark is now prominent in every slot.
  const dim =
    size === "xs" ? "h-10" :
    size === "sm" ? "h-12" :
    size === "lg" ? "h-20" :
    size === "xl" ? "h-28" :
    "h-16"; // md (default)
  return (
    <Link to={to} className={`inline-flex items-center gap-3 group ${className}`} data-testid="logo-link">
      <img
        src={LOGO_URL}
        alt="SelleCheck — Global Payments. Trusted Everywhere."
        className={`${dim} w-auto object-contain transition-transform group-hover:scale-[1.03]`}
      />
      {showTagline && (
        <span className="hidden sm:block text-xs uppercase tracking-[0.18em] text-slate-500 font-medium">
          Global payments. Trusted everywhere.
        </span>
      )}
    </Link>
  );
}
